import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Control, Form, Errors, actions } from 'react-redux-form'
import TreeView from '../Search/TreeView'
import Popup from "reactjs-popup";
import Button from 'UI/Button'
import { Checkbox } from 'material-ui';
import ValueStoryList from 'Search/ValueStories'
import ScrollArea from 'react-scrollbar'
//import Screen from 'UI/CustomComponents/Screen';

// Actions
import { updateOrganization, addRevenue, updateCurrency, updateCurrencyCode, capIQFetchData } from 'actions/discoveryActions'

import {
	getSPCapitalIQData,
	getSPCapitalIQLoading,
	getSPCapitalIQSuccess,
	getSPCapitalIQFailure
} from 'actions/spendActions'
import {
	userDetailsSuccess,
	userDetailsFailure,
	userDetailsLoading,
	fetchUserValueStories,
	fetchValueStories,
	fetchUserSharedValueStories,
	fetchValueStoriesLoading,
	fetchValueStoriesSuccess,
	fetchValueStoriesFailure,
} from 'actions/userActions'
import {
	toggleValueDriver,
	toggleSubLever
} from 'actions/valueDriverActions'
import { updateUserInput } from 'actions/subLeverCalculationActions'

// UI
import Select from 'react-select'


// Common Functions
import { subLeverChange } from 'components/BusinessValue/SubLeverChange'

// Utils
import { round, onChangeRemoveMask, formatThousands, getSubLeverIdObject, subLeverHasTotalSpend, removeMask, isDuplicate } from 'utils/Utils'

// Settings
import { validators, dropdownColourStyles } from 'Constants'

import DiscoveryCapIQSearch from './DiscoveryCapIQSearch';
import DiscoveryVsSearch from './DiscoveryVsSearch'
import Modal from 'reboron/OutlineModal';
import { modalStyle, emailmodalContentStyle } from 'Constants'
import {ControlTextE, SelectE, CheckboxE, ScreenE, PopupE} from 'UI/CustomComponents/Controls';

const autoHeightModalStyle = Object.assign({}, modalStyle)
autoHeightModalStyle.height = 'auto'
autoHeightModalStyle.width = '30%'

const defaultOptions = [
	{ value: 0, label: "" }];

const BLURPENAME = '|BLURPENAME';

export class DiscoveryForm extends PureComponent {

	constructor(props) {
		super(props)

		this.fetchValueStories = this.fetchValueStories.bind(this);
		this.fetchUserSharedValueStories = this.fetchUserSharedValueStories.bind(this);
		this.addCurrencyMask = this.addCurrencyMask.bind(this)
		this.calculateTotalSpendFromRevenue = this.calculateTotalSpendFromRevenue.bind(this)
		this.dispatchAddRevenue = this.dispatchAddRevenue.bind(this)
		this.getTotalSpend = this.getTotalSpend.bind(this)
		this.handleIndustryChange = this.handleIndustryChange.bind(this)
		this.handleLocationChange = this.handleLocationChange.bind(this)
		this.handleCurrencyChange = this.handleCurrencyChange.bind(this)
		this.handleTotalSpendBlur = this.handleTotalSpendBlur.bind(this)
		this.repositionInputCaret = this.repositionInputCaret.bind(this)
		this.capIqRadioButtonClicked = this.capIqRadioButtonClicked.bind(this)
		this.capIqDataCleared = this.capIqDataCleared.bind(this)
		this.closeCapIqPopUp = this.closeCapIqPopUp.bind(this)
		this.closeVsListPopUp = this.closeVsListPopUp.bind(this)
		this.isZero = this.notZero.bind(this)
		this.value = 0
		this.totalSpendTouched = false
		this.annualRevenueCaret = 0
		this.annualRevenueThousandsSeparatorCount = 0
		this.annualRevenueValue = null
		this.totalSpendCaret = 0
		this.totalSpendThousandsSeparftorCount = 0
		this.totalSpendValue = null
		this.state = {
			industryOption: [],
			selectedIndustry: '',
			selectedLocation: '',
			locationOption: [],
			currencyOption: [],
			selectedCurrency: '',
			selectedCurrencySymbol: '',
			showFloatingLabelFlag: false,
			selectedRegion: '',
			valueStory: '',
			isValueStoryNameEdit: false,
			organization: '',
			selectedCapIQCompanyId: '',
			open: false,
			closeCapIqPopUp: false,
			test: false,
			openVSList: false,
			valueStories: [],
			searchText: '',
			valueStoriesShared: [],
			isLoading: false,
			vsLoad: '',
			isCapIQLicesend: false
		}
		this.onTextChangeEvent = this.onTextChangeEvent.bind(this);
		this.onOrganizationChangeEvent = this.onOrganizationChangeEvent.bind(this);
		this.handleCapIQIdChange = this.handleCapIQIdChange.bind(this);
	}

	componentWillMount() {
		this.fetchUserValueStories();
		//if (this.props.newValueStory) {
		//this.dispatchAddRevenue(this.props.userData.AnnualRevenue)
		//}

		// Check for user inputted total spend
		const firstSubLeverTotalSpend = this.props.userData.BusinessValueToYou ? this.props.userData.BusinessValueToYou[0].ValueDriver[0].SubLever[0].UserInput[0].UserInput : null

		if (firstSubLeverTotalSpend !== '' && firstSubLeverTotalSpend !== null) this.totalSpendTouched = true

		this.setState({ valueStory: this.props.userData.ValueStoryName });
		this.setState({ organization: this.props.userData.Organization });

		if (this.props.userData.CapIQCompany) {
			this.setState({ selectedCapIQCompanyId: this.props.userData.CapIQCompany + ' | ' + this.props.userData.CapIQId }, this.callCapIQProcedure);
		}

		if (this.props.userData.Test !== undefined && this.props.userData.Test !== null) {
			this.setState({ test: this.props.userData.Test });
		}
	}

	componentDidMount() {
		this.loadData();
		//this.initialFieldValues();
		this.setState({ isCapIQLicesend: this.props.user.user.applicationFeatures.findIndex(a => a.Action === this.props.capIQ.capIQAction) > -1 ? true : false })
		this.fetchUserSharedValueStories()
		this.annualRevenueElement = document.getElementById('discovery.AnnualRevenue')
		this.totalSpendInMillionsElement = document.getElementById('discovery.TotalSpend')

		this.bindIndustryAndLocation();


		if (this.props.content.industries.indexOf(this.props.content.industries[0]) === 0) {
			this.formDispatch(actions.setErrors('discovery.Industry', true))
		} else {
			this.formDispatch(actions.change('discovery.Industry', this.props.content.industries[this.props.userData.Industry]));
			this.formDispatch(actions.setErrors('discovery.Industry', false))
		}

		if (!validators.notZero(this.props.userData.AnnualRevenue) || this.props.userData.AnnualRevenue === '' || this.props.userData.AnnualRevenue === null) {
			this.formDispatch(actions.setErrors('discovery.AnnualRevenue', {
				required: validators.required(this.props.userData.AnnualRevenue) && this.props.validation.required,
				isZero: (vals) => this.notZero(this.props.userData.AnnualRevenue) && this.props.validation.isZero
			}))
		} else {
			this.formDispatch(actions.setErrors('discovery.AnnualRevenue', false))
		}
	}

	fetchUserValueStories() {
		this.props.fetchValueStoriesLoading(true)
		this.props.fetchUserValueStories(this.props.user.user.Id)
			.then((result) => {
				this.props.fetchValueStoriesSuccess(result)
				for (var i = 0; i < result.data.Result.length; i++) {
					var obj = result.data.Result[i];
					if (obj.Id !== localStorage.getItem('id')) {
						break;
					}
				}
				for (var i = 0; i < result.data.Result.length; i++) {
					var obj = result.data.Result[i];
					if (obj.Id === localStorage.getItem('id')) {
						break;
					}
				}
			}).catch((error) => {
				this.props.fetchValueStoriesFailure(error.response.data.Message)
			})
	}

	loadData() {

		var array = [
			{ label: 'Total Invoice spend', value: 'Total Invoice spend' },
			{ label: 'Total Invoice Count', value: 'Total Invoice Count' },
			{ label: 'Total Purchase Order Spend', value: 'Total Purchase Order Spend' },
			{ label: 'Total Purchase Order Count', value: 'Total Purchase Order Count' },
		]

		const group = { defaultValue: undefined, groupLabel: 'CapIqId', groupName: 'CapIqId' }

		this.setState({
			group: group,
			items: array
		})

	}

	handleIndustryChange(value) {

		this.props.dispatchIndustryChange(this.props.content.industries.indexOf(value))
		const self = this;
		setTimeout(() => {
			if (!self.props.newValueStory) {
				let arr = []
				arr.push('4.3')
				arr.push('4.4')
				subLeverChange('', arr)
			}
			if (!this.totalSpendTouched) this.props.dispatchUpdateTotalSpend(this.calculateTotalSpendFromRevenue())
		}, 1)

		this.setState({ selectedIndustry: value });
		this.formDispatch(actions.change('discovery.Industry', value));


		if (this.props.content.industries.indexOf(this.props.content.industries[0]) === 0) {
			this.formDispatch(actions.setErrors('discovery.Industry', true))
			this.formDispatch(actions.change('discovery.Industry', ''));
		} else {
			this.formDispatch(actions.setErrors('discovery.Industry', false))
		}


	}

	handleLocationChange(value) {
		var result = this.props.content.regions.find(region => region.Country.toLowerCase() == value.toLowerCase())
		this.props.dispatchLocationChange(this.props.content.locations.indexOf(value), result.Region)
		//this.getCurrency(this.props.content.locations.indexOf(value))

		setTimeout(() => {
			if (!this.totalSpendTouched) this.props.dispatchUpdateTotalSpend(this.calculateTotalSpendFromRevenue())
		}, 1)

		this.setState({ selectedLocation: value });


	}

	handleCurrencyChange(value) {
		var result = this.state.currencyOption.find(currency => currency.value == value.value)
		//this.props.userData.CurrencyCode = value.value;
		//this.props.userData.Currency = this.props.currencySymbols[value.value];

		this.setState({ selectedCurrency: value });
		this.setState({ selectedCurrencySymbol: this.props.currencySymbols[value.value] });
		this.getCurrency(value);

		this.showModal("currencychange");
	}

	dispatchAddRevenue(revenue) {

		this.props.addRevenue(revenue)

		setTimeout(() => {
			if ((this.props.userData.TotalSpend === '' || this.props.userData.TotalSpend === null) || !this.totalSpendTouched)
				this.props.dispatchUpdateTotalSpend(this.calculateTotalSpendFromRevenue())

			this.repositionInputCaret('discovery.AnnualRevenue', this.annualRevenueCaret, this.annualRevenueThousandsSeparatorCount, this.props.userData.AnnualRevenue)
		}, 1)
	}

	calculateTotalSpendFromRevenue() {
		// Calculate Total Spend based on
		// Annual Revenue and Spend as Percentage of Revenue
		// if Annual Revenue is not empty
		if (this.props.userData.AnnualRevenue === '' || this.props.userData.AnnualRevenue === null) {
			return ''
		} else {
			//const totalSpend = round(this.props.spendAsPercentageOfRevenue / 100 * this.props.userData.AnnualRevenue, 2)
			const totalSpend = round(this.props.spendAsPercentageOfRevenue * this.props.userData.AnnualRevenue, 2)
			return totalSpend
		}
	}

	getTotalSpend(e) {
		this.totalSpendTouched = true
		const handleChange = this.props.handleChange

		let value = onChangeRemoveMask(e, this.state.selectedCurrencySymbol)

		// Total Spend user input is empty string or null
		if (!this.props.newValueStory && (value !== '' || value !== null)) {
			// Update Total Spend rows for all sub levers
			this.props.subLeverCalculationContent.forEach(function (obj) {

				const subLever = getSubLeverIdObject(obj.id)

				if (subLeverHasTotalSpend(obj.id)) {
					handleChange(value, subLever, 0)
				}
			})
		}

		// Update Total Spend in state
		this.props.dispatchUpdateTotalSpend(value)

		// Update controlled input
		this.props.dispatchTotalSpendChange(value)

		// add is-dirty state
		let el = document.getElementById("discovery.TotalSpend"),
			parent = el.parentNode
		parent.className += ' is-dirty'

		setTimeout(() => {
			// Update caret position
			if (this.totalSpendInMillionsElement === document.activeElement) {
				this.repositionInputCaret('discovery.TotalSpend', this.totalSpendCaret, this.totalSpendThousandsSeparatorCount, this.props.userData.TotalSpend)
			}
		}, 1)
	}

	handleTotalSpendBlur(e) {
		const handleChange = this.props.handleChange
		let value = onChangeRemoveMask(e, this.state.selectedCurrencySymbol)

		// Total Spend user input is empty string or null
		if (value === '' || value === null) {
			// Use default calculated Total Spend (Revenue * Industry BM percentage)
			value = this.calculateTotalSpendFromRevenue()


			// Clear Total Spend rows for all sub levers
			if (!this.props.newValueStory) {
				this.props.subLeverCalculationContent.forEach(function (obj) {

					const subLever = getSubLeverIdObject(obj.id)

					if (subLeverHasTotalSpend(obj.id)) {
						handleChange(null, subLever, 0)
					}
				})
			}
		}

		// Update Total Spend in state
		this.props.dispatchUpdateTotalSpend(value)

		// Update controlled input
		this.props.dispatchTotalSpendChange(value)
	}

	dispatchUpdateCurrency(currency) {
		let encodedCurrency = encodeURIComponent(currency)
		this.props.updateCurrency(encodedCurrency)
	}

	getCurrency(value) {
		this.dispatchUpdateCurrency(this.props.currencySymbols[value.value])
		this.props.updateCurrencyCode(value.value)
	}

	addCurrencyMask(value) {
		if (value === '' || value === null || value === '0') {

			if (this.formDispatch !== undefined) {
				this.formDispatch(actions.setErrors('discovery.AnnualRevenue', {
					required: validators.required(this.props.userData.AnnualRevenue) && this.props.validation.required,
					isZero: (vals) => this.notZero(this.props.userData.AnnualRevenue) && this.props.validation.isZero
				}))
				//this.formDispatch(actions.reset('discovery.AnnualRevenue'))
			}
			return ''
		} else {
			var temp = this.formDispatch !== undefined ? this.formDispatch(actions.setErrors('discovery.AnnualRevenue', false)) : null
			const regex = /\d*\.?\d{0,2}/g
			const filteredValue = regex.exec(value)

			if (filteredValue[0] === '') {
				return this.state.selectedCurrencySymbol + formatThousands(this.value) + ' M'
			} else {
				this.value = filteredValue[0]
				return this.state.selectedCurrencySymbol + formatThousands(this.value) + ' M'
			}
		}
	}

	repositionInputCaret(selector, lastCaretPosition, lastThousandsSeparatorCount, lastValue) {
		// Reposition Annual Revenue cursor after currency mask has been applied
		const el = document.getElementById(selector)
		if (!el) {
			return;
		}
		let val = el.value
		let thousandsSeparatorCount = val.split(",").length - 1
		let length = val.length

		let caretPosition = 0

		// Don't let caret go past Millions postfix
		if (lastCaretPosition >= val.length - 2) {
			el.selectionStart = length - 2
			el.selectionEnd = length - 2
			// If input is not empty
		} else if (el === document.activeElement && (lastValue.indexOf('M') > -1)) {
			if (thousandsSeparatorCount > lastThousandsSeparatorCount) {
				caretPosition = lastCaretPosition + 1
			} else if (thousandsSeparatorCount < lastThousandsSeparatorCount) {
				caretPosition = lastCaretPosition - 1
			} else {
				caretPosition = lastCaretPosition
			}

			el.selectionStart = caretPosition
			el.selectionEnd = caretPosition
			// If input is empty
		} else {
			el.selectionStart = length - 2
			el.selectionEnd = length - 2
		}

		//console.log('component did update', thousandsSeparatorCount, val, el.selectionStart, el.selectionEnd)
	}


	componentWillReceiveProps(nextProps) {
		/*
		Update Caret positions on user input
		 */
		const val = this.annualRevenueElement.value
		this.annualRevenueCaret = this.annualRevenueElement.selectionStart
		this.annualRevenueThousandsSeparatorCount = val.split(",").length - 1
		this.annualRevenueValue = val

		const val2 = this.totalSpendInMillionsElement.value
		this.totalSpendCaret = this.totalSpendInMillionsElement.selectionStart
		this.totalSpendThousandsSeparatorCount = val2.split(",").length - 1
		this.totalSpendValue = val2

		//console.log('component will receive props', this.annualRevenueThousandsSeparatorCount, el.value, el.selectionStart, el.selectionEnd)


		//bind industry option
		if (this.props.content !== nextProps.content) {
			this.props = nextProps;

			this.bindIndustryAndLocation();
		}
	}

	componentDidUpdate(nextProps, nextState) {
		if (this.annualRevenueElement === document.activeElement) {
			this.repositionInputCaret('discovery.AnnualRevenue', this.annualRevenueCaret, this.annualRevenueThousandsSeparatorCount, this.annualRevenueValue)
		}

		if (this.totalSpendInMillionsElement === document.activeElement) {
			this.repositionInputCaret('discovery.TotalSpend', this.totalSpendCaret, this.totalSpendThousandsSeparatorCount, this.totalSpendValue)
		}

		if (this.props !== undefined) {
			if (this.props.content.industries.indexOf(this.props.content.industries[this.props.userData.Industry]) > 0) {
				this.formDispatch(actions.change('discovery.Industry', this.props.content.industries[this.props.userData.Industry]));
			} else {
				this.formDispatch(actions.setErrors('discovery.Industry', true));
				this.formDispatch(actions.reset('discovery.Industry'));
			}

			if (this.props.userData.AnnualRevenue === '' || this.props.userData.AnnualRevenue === null || this.props.userData.AnnualRevenue === '0') {

				if (this.formDispatch !== undefined) {
					this.formDispatch(actions.setErrors('discovery.AnnualRevenue', {
						required: validators.required(this.props.userData.AnnualRevenue) && this.props.validation.required,
						isZero: (vals) => this.notZero(this.props.userData.AnnualRevenue) && this.props.validation.isZero
					}))
					//this.formDispatch(actions.reset('discovery.AnnualRevenue'))
				}
				return ''
			}
		}
	}

	bindIndustryAndLocation() {
		//bind industry option
		var array = [];
		this.props.content.industries.forEach((element) => {
			var obj = {};
			obj.label = element;
			obj.value = element;
			array.push(obj);
		});
		this.setState({ industryOption: array });

		// set default value for industry
		this.setState({ selectedIndustry: this.props.content.industries[this.props.userData.Industry] });

		//bind location option		
		var array1 = [];
		this.props.content.locations.forEach((element) => {
			var obj = {};
			obj.label = element;
			obj.value = element;
			array1.push(obj);
		});
		this.setState({ locationOption: array1 });

		//bind currency option		
		var array2 = [];
		let currencyCodes = this.props.content.currencyCodes;
		for (let i = 1; i < currencyCodes.length; i++) {
			let obj = { label: currencyCodes[i], value: currencyCodes[i].split(' - ')[0] }
			array2.push(obj);
		}
		this.setState({ currencyOption: array2 });

		// set default value for location 
		this.setState({ selectedLocation: this.props.content.locations[this.props.userData.Location] });

		var idx = array2.findIndex((element) => {
			return element.value === this.props.userData.CurrencyCode
		})

		if (idx === -1) {
			idx = array2.findIndex((element) => {
				return element.value === 'USD'
			})
		}

		let selectedCurrencySym = this.props.currencySymbols[array2[idx].value];

		this.getCurrency({ label: selectedCurrencySym, value: array2[idx].value })


		//this.dispatchUpdateCurrency(selectedCurrencySym);

		this.setState({ selectedCurrencySymbol: selectedCurrencySym });
		// set default value for currency 
		this.setState({ selectedCurrency: array2[idx] });
	}

	

	onTextChangeEvent(event) {
		this.setState({ valueStory: event.target.value !== undefined ? event.target.value : this.props.userData.ValueStoryName });
		this.props.userData.ValueStoryName = event.target.value;
		this.setState({ isValueStoryNameEdit: true });
	}

	onOrganizationChangeEvent(event) {
		this.setState({ organization: event.target.value !== undefined ? event.target.value : this.props.userData.Organization });
		this.props.userData.Organization = event.target.value;
		this.props.updateOrganization(this.props.userData.Organization);
		this.setState({ isOrganizationEdit: true });
	}

	handleCapIQIdChange(event) {
		this.setState({ capIQId: event.target.value !== undefined ? event.target.value : this.props.userData.CapIQId });
		this.props.userData.CapIQId = event.target.value;
		this.setState({ isCapIQIdEdit: true });
	}

	notZero(vals) {
		if ((vals !== null && vals !== '' && Number.parseFloat(removeMask(vals, this.state.selectedCurrencySymbol)) === 0)) {
			return false;
		}

		return true;
	}

	closeCapIqPopUp() {
		this.setState({ openCapIq: !this.state.openCapIq })
	}

	closeVsListPopUp() {
		this.setState({ openVSList: !this.state.openVSList, vsLoad: '' })
	}

	callCapIQProcedure() {
		let str = this.state.selectedCapIQCompanyId
		let id = str.split('|').pop().trim()
		this.props.dispatchCapIQChange(id)
		// this.props.getSPCapitalIQData(id)
		//     .then((result) => {
		//         this.props.getSPCapitalIQSuccess(result)
		// 		this.props.capIQFetchData(result.data.Result[0])
		//     }).catch((error) => {
		//         this.props.getSPCapitalIQFailure(error.response.data.Message)
		//     })
	}

	capIqDataCleared() {
		var array2 = [];
		let currencyCodes = this.props.content.currencyCodes;
		for (let i = 1; i < currencyCodes.length; i++) {
			let obj = { label: currencyCodes[i], value: currencyCodes[i].split(' - ')[0] }
			array2.push(obj);
		}
		this.setState({ currencyOption: array2 });
		let idx = array2.findIndex((element) => {
			return element.value === 'USD'
		})


		let selectedCurrencySym = this.props.currencySymbols[array2[idx].value];

		this.getCurrency({ label: selectedCurrencySym, value: array2[idx].value })


		//this.dispatchUpdateCurrency(selectedCurrencySym);

		this.setState({ selectedCurrencySymbol: selectedCurrencySym });
		// set default value for currency 
		this.setState({ selectedCurrency: array2[idx] });
		this.props.dispatchCapIQChange('clear')
		this.setState({ capIQId: '', selectedCapIQCompanyId: '', selectedLocation: this.props.content.locations[0], selectedIndustry: this.props.content.industries[0] })
	}

	capIqRadioButtonClicked(data) {
		this.props.userData.CapIQId = data.COMPANY_ID
		this.props.userData.CapIQCompany = data.COMPANY_NAME
		this.props.userData.Organization = data.COMPANY_NAME
		this.bindIndustryAndLocation()
		this.formDispatch(actions.change('discovery.Organization', data.COMPANY_NAME));
		if (this.props.userData.CapIQCompany) {
			this.setState({ selectedCapIQCompanyId: this.props.userData.CapIQCompany + ' | ' + this.props.userData.CapIQId, organization: data.COMPANY_NAME }, this.callCapIQProcedure);
		} else {
			this.setState({ selectedCapIQCompanyId: '' })
		}

		this.props.userData.AnnualRevenue = data.COMPANY_REVENUE ? data.COMPANY_REVENUE + '' : null;
		this.dispatchAddRevenue(this.props.userData.AnnualRevenue)
		//this.props.userData.Location = data.COUNTRY_NAME
		let idx = this.props.content.locations.findIndex(item => data.COUNTRY_NAME.toLowerCase() === item.toLowerCase())
		if (idx !== -1) {
			this.props.userData.Location = idx;
			this.setState({ selectedLocation: this.props.content.locations[idx] });
		} else {
			this.setState({ selectedLocation: this.props.content.locations[0] })
		}

		if (data.AVATAR_INDUSTRY) {
			const industryIdx = this.props.content.industries.findIndex(item => data.AVATAR_INDUSTRY.toLowerCase() === item.toLowerCase());
			if (industryIdx !== -1) {
				this.props.userData.Industry = industryIdx;
				this.formDispatch(actions.change('discovery.Industry', this.props.content.industries[industryIdx]));
				this.setState({ selectedIndustry: this.props.content.industries[industryIdx] });
			} else {
				this.setState({ selectedIndustry: this.props.content.industries[0] });
			}
		}
	}

	showModal(action) {
		this.refs[action].show()
	}

	hideModal(action) {
		this.refs[action].hide()
	}

	selectIsTestChk(e) {
		this.setState({ test: !this.state.test }, () => {
			this.props.userData.Test = this.state.test;
		});
	}
	fetchUserSharedValueStories() {
		this.props.fetchValueStoriesLoading(true)
		this.setState({ isError: false, message: '', })
		this.props.fetchUserSharedValueStories(this.props.user.user.Id)
			.then((result) => {
				this.props.fetchValueStoriesSuccess(result)
				var obj = [];
				for (var i = 0; i < result.data.Result.length; i++) {

					obj.push(result.data.Result[i])
				}
				let temp = obj;
				temp.forEach((element, i) => {
					element.content = false;
					element.index = i;
				});
				this.setState({ valueStoriesShared: temp })
			}).catch((error) => {
				this.props.fetchValueStoriesFailure(error.response.data.Message)
				this.setState({
					message: error.response.data.Message, isLoading: false, isError: true
				})
			})
	}
	fetchValueStories() {
		let searchText = this.state.organization;
		let prevText = this.state.searchText;
		let sharedVs = this.state.valueStoriesShared;
		if (searchText != prevText) {
			this.props.fetchValueStoriesLoading(true)
			this.setState({ isError: false, message: '', vsLoad: 'true' })
			this.props.fetchValueStories(searchText)
				.then((result) => {
					this.props.fetchValueStoriesSuccess(result)
					var obj = [];
					for (var i = 0; i < result.data.Result.length; i++) {

						obj.push(result.data.Result[i])
					}
					let temp = obj;
					let vsList;
					temp.forEach((element, i) => {
						element.content = false;
						element.index = i;
					});
					if (sharedVs.length > 0) {
						vsList = temp.filter(obj => !sharedVs.filter(xobj => obj.VSID == xobj.VSId).length)
					}
					this.setState({ valueStories: vsList, searchText: searchText, vsLoad: '' })

				}).catch((error) => {
					this.props.fetchValueStoriesFailure(error.response.data.Message)
					this.setState({
						message: error.response.data.Message, isLoading: false, isError: true
					})
				})
		}
	}

	render() {
		return (
			<ScreenE readOnly={!this.props.userData.AllowEdit} lastUpdated={new Date().getTime()}>
				<div>
					<div className="form-header">
						<div className="grid-x">
							<div className="medium-4 medium-offset-8" style={{ textAlign: 'right', height: '20px' }}>
								{
									this.props.userData.VSId !== undefined ? this.props.content.vsId + ": " + this.props.userData.VSId : null
								}
							</div>
						</div>
						<div className="grid-x">
							<div className="medium-8">
								{this.state.organization}
							</div>
							<div className="medium-4">
								<div className="float-right">
									<div className="float-left width30">
										<CheckboxE checked={this.state.test} onClick={(e) => this.selectIsTestChk(e)} />
									</div>
									<div className="float-left line-height25 test-label">{this.props.content.testValueStory}</div>
								</div>
							</div>
						</div>
					</div>
					<div className="formBg">
						<Form model="discovery" method="post"
							validators={{
								AnnualRevenue: (vals) => this.notZero(this.props.userData.AnnualRevenue)
							}}
							getDispatch={(dispatch) => this.formDispatch = dispatch}>
							<div className="grid-x" key="1">
								<div className="mandatory-text medium-12 large-12">
									<span className="asterisk">*</span> {this.props.content.mandatoryFields}
								</div>
							</div>
							<div className="grid-x"  key="2">
								<div className="medium-12 large-12"  key="5">
									<div className="label"  key="">{this.props.content.valueStoryName} <span className="asterisk">*</span></div>
									<div className="control-wrapper">
										<ControlTextE
											model="discovery.ValueStoryName"
											id="discovery.ValueStoryName"
											value={this.state.valueStory}
											defaultValue={this.state.valueStory}
											onChange={this.onTextChangeEvent}
											validators={{
												required: validators.required
												, duplicate: (vals) => isDuplicate(this.props.user.valueStories, vals, this.props.userData.VSId)
											}}
											validateOn="change"
										/>
										<Errors
											className="errors"
											model="discovery.ValueStoryName"
											show="touched"
											messages={{
												required: this.props.validation.required
												, duplicate: this.props.validation.duplicateValueStoryName
											}}
										/>
									</div>
								</div>
							</div>
							<div className="grid-x row"  key="3">
								
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.capIQId}</div>
									<div className="control-wrapper capIq-popup">
										<ControlTextE
											model="discovery.CapIQId"
											id="discovery.CapIQId"
											disabled = {!this.state.isCapIQLicesend}
											value={this.state.selectedCapIQCompanyId}
											defaultValue={this.state.selectedCapIQCompanyId}
											title={this.state.selectedCapIQCompanyId}
											onChange={this.handleCapIQIdChange}
										/>
										{
											<PopupE className="large-popup"
												trigger={
													<img Style="cursor: pointer" className="control-image" width="15" src="/images/search_big_inactive.svg" />}
												position="left center"
												open={this.state.openCapIq}
												disabled = {!this.state.isCapIQLicesend}
												onOpen={this.closeCapIqPopUp}
												closeOnDocumentClick
											>
												<div>
													<DiscoveryCapIQSearch
														contentData={this.props.content}
														capIqRadioButtonClicked={this.capIqRadioButtonClicked}
														capIqDataCleared={this.capIqDataCleared}
														close={this.closeCapIqPopUp}
													/>
												</div>
											</PopupE>
										}
									</div>
								</div>
							</div>
							<div className="grid-x row"  key="4">
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.company} <span className="asterisk">*</span></div>
									<div className="control-wrapper">
										<ControlTextE
											model="discovery.Organization"
											id="discovery.Organization"
											value={this.props.userData.Organization}
											// defaultValue={this.props.userData.Organization}
											onChange={this.onOrganizationChangeEvent}
											validators={{
												required: validators.required
											}}
											validateOn="change"
										/>
										<Errors
											className="errors"
											model="discovery.Organization"
											show="touched"
											messages={{
												required: this.props.validation.required
											}}
										/>
									</div>
								</div>
							</div>
							<div className="grid-x row"  key="5">
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.industriesLabel} <span className="asterisk">*</span></div>
									<div className="control-wrapper">
										<SelectE
											className="border-less-DD"
											model="discovery.Industry"
											id="discovery.Industry"
											name="discovery.Industry"
											placeholder={this.props.content.industriesLabel}
											value={this.state.industryOption.filter(option => option.label === this.state.selectedIndustry)}
											noOptionsMessage={() => null}
											onChange={(value) => this.handleIndustryChange(value.label)}
											validators={{ required: (value) => validators.validSelect(this.props.content.industries.indexOf(value.label)) }}
											validateOn="change"
											options={this.state.industryOption}
											isSearchable={false} styles={dropdownColourStyles}
										/>
										<Errors
											className="errors errorsMargin"
											model="discovery.Industry"
											//show="touched"
											messages={{
												required: this.props.validation.required
											}}
										/>
										<ControlTextE
											model="discovery.Industry"
											id="discovery.Industry1"
											hidden
											value={this.state.selectedIndustry}
											defaultValue={this.state.selectedIndustry}
											validators={{
												required: (value) => validators.validIndustry(this.state.selectedIndustry)
											}}
											validateOn="change"
										/>
									</div>
								</div>
							</div>
							<div className="grid-x row"  key="6">
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.locationsLabel} <span className="asterisk">*</span></div>
									<div className="control-wrapper">
										<SelectE
											className="border-less-DD"
											model="discovery.Location"
											id="discovery.Location"
											placeholder={this.props.content.locationsLabel}
											value={this.state.locationOption.filter(option => option.label === this.state.selectedLocation)}
											noOptionsMessage={() => null}
											onChange={(value) => this.handleLocationChange(value.label)}
											options={this.state.locationOption}
											isSearchable={false}
											validators={{
												required: validators.required
											}}
											validateOn="change" styles={dropdownColourStyles}
										/>
										<Errors
											className="errors errorsMargin"
											model="discovery.Location"
											show="touched"
											messages={{
												required: this.props.validation.required
											}}
										/>
									</div>
								</div>
							</div>
							<div className="grid-x row"  key="7">
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.currency} <span className="asterisk">*</span></div>
									<div className="control-wrapper">
										<SelectE
											className="border-less-DD"
											model="discovery.CurrencyCode"
											id="discovery.CurrencyCode"
											placeholder={this.props.content.currencyCodes[0]}
											value={this.state.currencyOption.filter(option => option.value === this.state.selectedCurrency.value)}
											noOptionsMessage={() => null}
											onChange={(value) => this.handleCurrencyChange(value)}
											options={this.state.currencyOption}
											isSearchable={false}
											validators={{
												required: validators.required
											}}
											validateOn="change" styles={dropdownColourStyles}
										/>
										<Modal
											ref={'currencychange'}
											keyboard={() => this.callback()}
											modalStyle={autoHeightModalStyle}
											contentStyle={emailmodalContentStyle}>
											<div className="grid-x">
												<div className="medium-12">
													{this.props.content.currencyChangeAlert}
												</div>
												<div className="medium-12 popupOkBtn">
													<div className="float-right">
														<Button onClick={() => this.hideModal("currencychange")}
															content='OK'
														/>
													</div>
												</div>
											</div>
										</Modal>
									</div>
								</div>
							</div>
							<div className="grid-x row"  key="8">
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.revenue} <span className="asterisk">*</span></div>
									<div className="control-wrapper">
										<ControlTextE
											model="discovery.AnnualRevenue"
											id="discovery.AnnualRevenue"
											value={this.addCurrencyMask(this.props.userData.AnnualRevenue)}
											defaultValue={this.addCurrencyMask(this.props.userData.AnnualRevenue)}
											onChange={e => { this.dispatchAddRevenue(onChangeRemoveMask(e, this.state.selectedCurrencySymbol)) }}
											validators={{
												required: validators.required,
												isZero: (vals) => this.notZero(this.props.userData.AnnualRevenue)

											}}

											validateOn="change"
										/>
										<Errors
											className="errors"
											model="discovery.AnnualRevenue"
											show="touched"
											messages={{
												required: this.props.validation.required,
												isZero: this.props.validation.isZero
											}}
										/>
									</div>
								</div>
							</div>
							<div className="grid-x row"  key="9">
								<div className="medium-12 large-12">
									<div className="label">{this.props.content.spend}</div>
									<div className="control-wrapper">
										<ControlTextE
											model="discovery.TotalSpend"
											id="discovery.TotalSpend"
											value={this.addCurrencyMask(this.props.userData.TotalSpend)}
											defaultValue={this.addCurrencyMask(this.props.userData.TotalSpend)}
											onChange={(e) => { this.getTotalSpend(e) }}
											onBlur={(e) => this.handleTotalSpendBlur(e)}
										/>
									</div>
								</div>
							</div>
						</Form>
					</div>
				</div>
			</ScreenE>
		)
	}
}

const mapStateToProps = (state) => {
	return {
		user: state.default,
		currency: decodeURIComponent(state.valueStory ? state.valueStory.Currency : state.companyProfileData[0].currencyCode),
		spendAsPercentageOfRevenue: state.spendAsPercentageOfRevenue,
		validation: state.content.validation,
		contentPE: state.contentPE,
		companyData: state.companyProfileData,
		selectedValueStory: state.selectedValueStory,
		currencySymbols: state.content.CurrencySymbols,
		userData: state.valueStory,
		newValueStory: state.isNewValueStory,
		searchResultData: state.searchResultData,
		capIQ: state.content.spendAnalysis.detailedFile,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		fetchUserValueStories: (id) => dispatch(fetchUserValueStories(id)),
		fetchValueStoriesLoading: (bool) => dispatch(fetchValueStoriesLoading(bool)),
		fetchValueStoriesSuccess: (valueStories) => dispatch(fetchValueStoriesSuccess(valueStories)),
		fetchValueStoriesFailure: (error) => dispatch(fetchValueStoriesFailure(error)),
		updateOrganization: (revenue) => dispatch(updateOrganization(revenue)),
		addRevenue: (revenue) => dispatch(addRevenue(revenue)),
		updateCurrency: (currency) => dispatch(updateCurrency(currency)),
		updateCurrencyCode: (currencyCode) => dispatch(updateCurrencyCode(currencyCode)),
		toggleValueDriver: (id, bool) => dispatch(toggleValueDriver(id, bool)),
		toggleSubLever: (id, bool) => dispatch(toggleSubLever(id, bool)),
		handleChange: (value, subLeverId, rowNumber) => dispatch(updateUserInput(value, subLeverId, rowNumber)),
		userDetailsLoading: (bool) => dispatch(userDetailsLoading(bool)),
		userDetailsSuccess: (bool) => dispatch(userDetailsSuccess(bool)),
		userDetailsFailure: (error) => dispatch(userDetailsFailure(error)),
		fetchValueStories: (id) => dispatch(fetchValueStories(id)),
		fetchUserSharedValueStories: (id) => dispatch(fetchUserSharedValueStories(id)),
		getSPCapitalIQSuccess: message => dispatch(getSPCapitalIQSuccess(message)),
		getSPCapitalIQFailure: error => dispatch(getSPCapitalIQFailure(error)),
		getSPCapitalIQLoading: bool => dispatch(getSPCapitalIQLoading(bool)),
		getSPCapitalIQData: (CapIQID) => dispatch(getSPCapitalIQData(CapIQID)),
		capIQFetchData: (capIQData) => dispatch(capIQFetchData(capIQData))
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(DiscoveryForm)
